// 工事新規作成画面
import React, { useState, useEffect, useCallback, useRef } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Grid,
  Theme,
  Divider,
  Button,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  LinearProgress
} from '@material-ui/core';
import { makeStyles, createStyles, withStyles } from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import NumberInput from '../components/NumberInput';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import DeleteIcon from '@material-ui/icons/Delete';
import './List.css';
import { useHistory, Redirect } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import {
  mainBlueColor,
  btnColor,
  isLoggedIn,
  invalidPhoneNumberRegex,
  userMenuId,
  userIdState
} from '../GlobalState';
import { getEmployeeMasterList } from '../apicalls/employeeMaster';
import {
  getConstructionTypes,
  getScaleList,
  getPrefectureList,
  getAssigneeRoles,
  saveConstruction,
  getConstructionClientDetails
} from '../apicalls/construction';
import { fetchAddressFromPostalCode } from '../apicalls/createCustomer';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import AddToPhotosIcon from '@material-ui/icons/AddToPhotos';
import { parsePrice } from '../utils';
import _, { sample } from 'lodash';
import { DatePickerInput } from '../components/atoms';
import HelpIcon from '@material-ui/icons/Help';
import { ConstructionSiteImg } from '../components/ConstructionSiteImg';
import { formatDatetime } from '../utils/common';
import { ConstructSiteMap } from '../components/ConstructSiteMap';
import axios from 'axios';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { TTopicPathState } from '../components/topicPath/type/Type';
import { getUserSelectOptions } from '../utils/processAndTaskFormUtils';
import LoadingComponent from '../components/LoadingComponent';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

export const CreateConstructionList: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [isPhoneNumber] = useRecoilState(invalidPhoneNumberRegex);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      inputContainer2: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        marginTop: 5,
        width: '100%'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        minHeight: 40,
        maxHeight: 150,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputnew: {
        minHeight: 100,
        maxHeight: 120,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },

      inputMainContainer1: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 80,
        alignItems: 'center',
        width: '100%'
      },
      textMainContainer1: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 80,
        alignItems: 'center'
      },
      textMainContainer2: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 125,
        alignItems: 'center'
      },
      textContainer1: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input1: {
        minHeight: 60,
        width: '100%'
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      inputContainerSelectBoxAlignRight: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%',
        textAlign: 'right'
      },
      textContainerPrice: {
        marginLeft: 10,
        marginRight: 13,
        textAlign: 'right',
        width: '100%'
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        minHeight: 48,
        width: '100%'
      },
      inputBottom: {
        height: 30,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputBottomAlignRight: {
        height: 30,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1,
        textAlign: 'right'
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: 16
      },
      inputPostalCode: {
        height: 40,
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      progress: {
        backgroundColor: '#c1c1c1',
        '& .MuiLinearProgress-barColorPrimary': {
          backgroundColor: mainColor
        }
      }
    })
  );

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const [loginUserId] = useRecoilState(userIdState);
  const [rowCount, setRowCount] = useState<any>([1]);
  const [rowCount2, setRowCount2] = useState<any>([1]);
  const [assigneeUser, setAssigneeUser] = useState<any>([loginUserId]);
  const [assigneeRole, setAssigneeRole] = useState<any>([1]); // 担当役割の初期値を営業担当で設定
  const [contributionList, setContributionList] = useState<any>([100]);
  const [assigneeOutsidePartner, setAssigneeOutsidePartner] = useState<any>([
    0
  ]);
  const [assigneeOutsidePartnerRole, setAssigneeOutsidePartnerRole] =
    useState<any>([0]);

  const classes = useStyles();
  const history: any = useHistory();
  const matches2 = useMediaQuery('(min-width:900px)');

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const [userMenu] = useRecoilState(userMenuId);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [typesData, setTypesData] = useState([]);
  const [scaleData, setScaleData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [prefectureData, setPrefectureData] = useState<
    { name: string; id: number }[]
  >([]);
  const [assigneeRoleData, setAssigneeRoleData] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');

  const [code, setCode] = useState('');
  const [constructType, setConstructType] = useState<number>(0);
  const [renewStatus, setRenewStatus] = useState<number>(0);
  const [buildingScale, setBuildingScale] = useState<number>(0);
  const [name, setName] = useState('');
  const [sitePrefecture, setSitePrefecture] = useState<number>(0);
  const [sitePrefectureName, setSitePrefectureName] = useState<string>('');
  const [siteAddress1, setSiteAddress1] = useState('');
  const [siteAddress2, setSiteAddress2] = useState('');
  const [siteAddress3, setSiteAddress3] = useState('');
  const site_address = siteAddress1 + siteAddress2 + siteAddress3;
  const [isAddressChanged, setIsAddressChanged] = useState(false);
  const [remarks, setRemarks] = useState<string>('');
  const [contractorPrefecture, setContractorPrefecture] = useState<number>(0);
  const [contractorAddress1, setContractorAddress1] = useState('');
  const [contractorAddress2, setContractorAddress2] = useState('');
  const [contractorAddress3, setContractorAddress3] = useState('');
  const [contractorName, setContractorName] = useState('');
  const [contractorTel, setContractorTel] = useState('');
  const [progress, setProgress] = useState<number>(1);
  const [plannedCost, setPlannedCost] = useState<number>(0);
  const [plannedDays, setPlannedDays] = useState<number>(0);
  const [smallExpenses, setSmallExpenses] = useState<number | ''>(0);

  const [contractDate, setContractDate] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [billingDate, setBillingDate] = useState('');
  const [paymentDate, setPaymentDate] = useState('');
  const [failureDate, setFailureDate] = useState('');
  const [inspectionDate, setInspectionDate] = useState('');

  const [contractTaxRate, setContractTaxRate] = useState<number>(10);

  const [expectedContractDate, setExpectedContractDate] = useState('');
  const [expectedStartDate, setExpectedStartDate] = useState('');
  const [expectedEndDate, setExpectedEndDate] = useState('');
  const [expectedPaymentDate, setExpectedPaymentDate] = useState('');

  const [clientName, setClientName] = useState('');
  const [clientTel, setClientTel] = useState('');
  const [clientPrefecture, setClientPrefecture] = useState('');
  const [clientAddress1, setClientAddress1] = useState('');
  const [clientAddress2, setClientAddress2] = useState('');
  const [clientAddress3, setClientAddress3] = useState('');

  const [companyName, setCompanyName] = useState('');
  const [companyCode, setCompanyCode] = useState('');
  const [companyPostalCode1, setCompanyPostalCode1] = useState('');
  const [companyPostalCode2, setCompanyPostalCode2] = useState('');
  const [companyAddress, setCompanyAddress] = useState('');
  const [companyPhoneNumber, setCompanyPhoneNumber] = useState('');
  const [companyFaxNumber, setCompanyFaxNumber] = useState('');
  const [latitude, setLatitude] = useState(35.69575);
  const [longitude, setLongitude] = useState(139.77521);
  const [isMarkerChecked, setIsMarkerChecked] = useState(false);

  const [possibleTime, setPossibleTime] = useState('');
  const [parkSpace, setParkSpace] = useState('');
  const [smokingRule, setSmokingRule] = useState('');
  const [importantOthers, setImportantOthers] = useState('');

  const [janitorName, setJanitorName] = useState('');
  const [janitorPhoneNumber, setJanitorPhoneNumber] = useState('');
  const [janitorFaxNumber, setJanitorFaxNumber] = useState('');
  const [janitorWorkHours, setJanitorWorkHours] = useState<string>('');
  const [janitorOthers, setJanitorOthers] = useState('');

  const [constructId, setConstructId] = useState<number | null>(null);
  const [isPosted, setIsPosted] = useState<boolean>(false);

  const [showLinearProgress, setShowLinearProgress] = useState(false);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const [selectedContractDate, setSelectedContractDate] =
    useState<Date | null>(null);
  const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(null);
  const [selectedBillingDate, setSelectedBillingDate] =
    useState<Date | null>(null);
  const [selectedPaymentDate, setSelectedPaymentDate] =
    useState<Date | null>(null);
  const [selectedFailureDate, setSelectedFailureDate] =
    useState<Date | null>(null);
  const [selectedInspectionDate, setSelectedInspectionDate] =
    useState<Date | null>(null);
  const [selectedExpectedContractDate, setSelectedExpectedContractDate] =
    useState<Date | null>(null);
  const [selectedExpectedStartDate, setSelectedExpectedStartDate] =
    useState<Date | null>(null);
  const [selectedExpectedEndDate, setSelectedExpectedEndDate] =
    useState<Date | null>(null);
  const [selectedExpectedPaymentDate, setSelectedExpectedPaymentDate] =
    useState<Date | null>(null);

  /**
   * 契約日
   */
  const handleContractDateChange = (date: Date | null) => {
    setSelectedContractDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setContractDate(finaldate);
  };

  /**
   * 着工日
   */
  const handleStartDateChange = (date: Date | null) => {
    setSelectedStartDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setStartDate(finaldate);
  };

  /**
   * 竣工日
   */
  const handleEndDateChange = (date: Date | null) => {
    setSelectedEndDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setEndDate(finaldate);
  };

  /**
   * 請求日
   */
  const handleBillingDateChange = (date: Date | null) => {
    setSelectedBillingDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setBillingDate(finaldate);
  };

  /**
   * 完工入金日
   */
  const handlePaymentDateChange = (date: Date | null) => {
    setSelectedPaymentDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setPaymentDate(finaldate);
  };

  /**
   * 不成立日
   */
  const handleFailureDateChange = (date: Date | null) => {
    setSelectedFailureDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setFailureDate(finaldate);
  };

  /**
   * 点検日
   */
  const handleInspectionDateChange = (date: Date | null) => {
    setSelectedInspectionDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setInspectionDate(finaldate);
  };

  /**
   * 契約予定日・着工予定日
   */
  const handleExpectedContractDateChange = (date: Date | null) => {
    setSelectedExpectedContractDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setExpectedContractDate(finaldate);
  };

  const handleExpectedStartDateChange = (date: Date | null) => {
    setSelectedExpectedStartDate(date);
    var finaldate: any = date?.toISOString().split('T')[0];
    setExpectedStartDate(finaldate);

    let endDate = selectedExpectedEndDate;
    let startDate = date;

    if (endDate !== null && startDate !== null) {
      let diff = endDate?.getTime() - startDate?.getTime();
      let msInDay = 1000 * 3600 * 24;
      setPlannedDays(Math.floor(diff / msInDay));
    }
  };

  /**
   * 竣工予定日
   */
  const handleExpectedEndDateChange = (date: Date | null) => {
    setSelectedExpectedEndDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setExpectedEndDate(finaldate);

    let endDate = date;
    let startDate = selectedExpectedStartDate;

    if (endDate !== null && startDate !== null) {
      let diff = endDate?.getTime() - startDate?.getTime();
      let msInDay = 1000 * 3600 * 24;
      setPlannedDays(Math.floor(diff / msInDay));
    }
  };

  /**
   * 入金予定日
   */
  const handleExpectedPaymentDateChange = (date: Date | null) => {
    setSelectedExpectedPaymentDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setExpectedPaymentDate(finaldate);
  };

  const [executionCost, setExecutionCost] = useState<number | ''>(0);

  const [smallExpenseItems, setSmallExpenseItems] = useState<any>([]);

  const addNewSmallExpenseItems = () => {
    let copySmallExpenseItems = [...smallExpenseItems];
    let i = copySmallExpenseItems.length;
    let newItem: any = {
      id: '',
      name: '',
      price: ''
    };
    if (i) {
      newItem.id = copySmallExpenseItems[i - 1].id + 1;
    } else {
      newItem.id = 1;
    }
    copySmallExpenseItems.push(newItem);
    setSmallExpenseItems([...copySmallExpenseItems]);
  };

  const deleteSmallExpenseItems = (i: number) => {
    let copySmallExpenseItems: any[] = _.cloneDeep(smallExpenseItems);
    let newSmallExpenseItems = copySmallExpenseItems.filter(
      item => item.id !== i
    );
    setSmallExpenseItems(newSmallExpenseItems);
    if (newSmallExpenseItems.length > 0) {
      let items = [...newSmallExpenseItems];
      let priceArray: number[] = [];
      items.map(item => priceArray.push(parseInt(item.price) || 0));
      let totalPrice: number = priceArray.reduce((a, b) => a + b);
      setSmallExpenses(totalPrice);
      setExecutionCost(totalPrice);
    } else {
      setSmallExpenses(0);
      setExecutionCost(0);
    }
  };

  const additionSmallExpenseItemsPrice = () => {
    if (smallExpenseItems.length > 0) {
      let items = [...smallExpenseItems];
      let priceArray: number[] = [];
      items.map(item => priceArray.push(item.price));
      let totalPrice: number = priceArray.reduce((a, b) => a + b);
      setSmallExpenses(totalPrice);
      setExecutionCost(totalPrice);
    } else {
      setSmallExpenses(0);
      setExecutionCost(0);
    }
  };

  const getListOfConstructionTypes = useCallback(() => {
    getConstructionTypes().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setTypesData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfScales = useCallback(() => {
    getScaleList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setScaleData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfAssigneeRoles = useCallback(() => {
    getAssigneeRoles().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setAssigneeRoleData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfPrefectures = useCallback(() => {
    getPrefectureList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setPrefectureData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfUsers = useCallback(() => {
    getEmployeeMasterList('', 1).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setUserData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getTheDetailsOfConstructionClients = useCallback(() => {
    getConstructionClientDetails(history.location.state.state).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setClientName(data.data.client_name);
            setClientTel(data.data.client_tel);
            setClientPrefecture(data.data.client_prefecture);
            setClientAddress1(data.data.client_address1);
            setClientAddress2(data.data.client_address2);
            setClientAddress3(data.data.client_address3);
            setCompanyName(data.data.company.name);
            setCompanyCode(data.data.company.code);
            setCompanyPostalCode1(data.data.company.postal_code.slice(0, 3));
            setCompanyPostalCode2(data.data.company.postal_code.slice(-4));
            setCompanyAddress(data.data.company.address);
            setCompanyPhoneNumber(data.data.company.phone_number);
            setCompanyFaxNumber(data.data.company.fax_number);
          }
        }
      }
    });
  }, [changeLoggedInData, history.location.state]);

  useEffect(() => {
    getListOfConstructionTypes();
    getListOfScales();
    getListOfPrefectures();
    getListOfUsers();
    getListOfAssigneeRoles();
    getTheDetailsOfConstructionClients();
  }, [
    getListOfConstructionTypes,
    getListOfScales,
    getListOfPrefectures,
    getListOfUsers,
    getListOfAssigneeRoles,
    getTheDetailsOfConstructionClients
  ]);

  const saveConstructionDetails = async () => {
    setShowLinearProgress(true);
    let small_expense_item: any = [];
    for (let n = 0; n < smallExpenseItems.length; n++) {
      if (
        smallExpenseItems[n].price !== '' &&
        smallExpenseItems[n].name.length <= 30
      ) {
        small_expense_item[n] = {
          name: smallExpenseItems[n].name,
          price: smallExpenseItems[n].price
        };
      } else if (smallExpenseItems[n].name.length > 30) {
        setErrorMessage('経費項目は30文字以内で入力してください。');
        setOpen(true);
        return;
      } else if (smallExpenseItems[n].price === '') {
        setErrorMessage('金額を入力してください。');
        setOpen(true);
        return;
      }
    }
    setSmallExpenseItems(small_expense_item);

    let contriSum = 0;
    for (let i = 0; i < contributionList.length; i++) {
      contriSum += contributionList[i];
    }
    if (code.trim() !== '' && code.length > 10) {
      setErrorMessage('工事番号は10文字以内で記入してください。');
      setOpen(true);
    } else if (constructType === 0 || !constructType) {
      setErrorMessage('案件種別を選択してください。');
      setOpen(true);
    } else if (renewStatus === 0) {
      setErrorMessage('「新規」または「リピート」を選択してください。');
      setOpen(true);
    } else if (name.trim() === '') {
      setErrorMessage('工事件名を入力してください。');
      setOpen(true);
    } else if (
      userMenu != 'Storage' &&
      userMenu != 'SiteManage' &&
      progress === 0
    ) {
      setErrorMessage('進行状況を入力してください。');
      setOpen(true);
    } else if (
      contractorTel.trim() !== '' &&
      (isPhoneNumber.test(contractorTel.trim()) ||
        contractorTel.trim().length > 20)
    ) {
      setErrorMessage('連絡先TELが無効です。');
      setOpen(true);
    } else if (
      userMenu != 'Storage' &&
      userMenu != 'SiteManage' &&
      assigneeUser.length === 0
    ) {
      setErrorMessage('担当者入力してください。');
      setOpen(true);
    } else if (userMenu != 'Storage' && assigneeRole.length === 0) {
      setErrorMessage('担当役割入力してください。');
      setOpen(true);
    } else if (userMenu != 'Storage' && contributionList.length === 0) {
      setErrorMessage('貢献度入力してください。');
      setOpen(true);
    } else if (
      new Set(assigneeOutsidePartner).size !== assigneeOutsidePartner.length
    ) {
      setErrorMessage('社外パートナーが重複しています。');
      setOpen(true);
    } else if (userMenu != 'Storage' && contriSum !== 100) {
      setErrorMessage('貢献度の合計は100％でなければなりません。');
      setOpen(true);
    } else if (
      companyPhoneNumber.trim() !== '' &&
      (isPhoneNumber.test(companyPhoneNumber.trim()) ||
        companyPhoneNumber.trim().length > 20)
    ) {
      setErrorMessage('無効な電話番号です。');
      setOpen(true);
    } else if (
      companyPostalCode1 !== '' &&
      companyPostalCode2 !== '' &&
      (companyPostalCode1.length !== 3 || companyPostalCode2.length !== 4)
    ) {
      setErrorMessage('郵便番号の形式が間違っています。');
      setOpen(true);
    } else if (possibleTime.length > 200) {
      setErrorMessage('工事可能時間は200文字以内で入力してください。');
      setOpen(true);
    } else if (parkSpace.length > 200) {
      setErrorMessage('駐車スペースは200文字以内で入力してください。');
      setOpen(true);
    } else if (smokingRule.length > 200) {
      setErrorMessage('喫煙ルールは200文字以内で入力してください。');
      setOpen(true);
    } else if (importantOthers.length > 200) {
      setErrorMessage(
        '施工に関する注意点：その他は200文字以内で入力してください。'
      );
      setOpen(true);
    } else if (janitorName.length > 200) {
      setErrorMessage('管理人名は200文字以内で入力してください。');
      setOpen(true);
    } else if (
      janitorPhoneNumber.trim() !== '' &&
      (isPhoneNumber.test(janitorPhoneNumber.trim()) ||
        janitorPhoneNumber.trim().length > 20)
    ) {
      setErrorMessage('管理人TELが無効です。');
      setOpen(true);
    } else if (janitorFaxNumber.length > 20) {
      setErrorMessage('管理人FAXは20文字以内で入力してください。');
      setOpen(true);
    } else if (janitorWorkHours.length > 200) {
      setErrorMessage(
        '管理会社情報：勤務時間は200文字以内で入力してください。'
      );
      setOpen(true);
    } else if (janitorOthers.length > 200) {
      setErrorMessage('管理会社情報：その他は200文字以内で入力してください。');
      setOpen(true);
    } else if (siteAddress1.length > 10) {
      setErrorMessage('現場住所/市町村区は10文字以内で入力してください。');
      setOpen(true);
    } else if (siteAddress2.length > 20) {
      setErrorMessage('現場住所/町名・番地は20文字以内で入力してください。');
      setOpen(true);
    } else if (siteAddress3.length > 30) {
      setErrorMessage(
        '現場住所/現場住所建物名/部屋番号は30文字以内で入力してください。'
      );
      setOpen(true);
    } else {
      let l1 = assigneeUser.length;
      let l2 = assigneeRole.length;
      let l3 = contributionList.length;
      let l5 = assigneeOutsidePartner.length;
      let l6 = assigneeOutsidePartnerRole.length;

      let flag = false;
      if (l1 === l2 && l2 === l3) {
        flag = true;
      }
      // データ保存用の配列
      let items: any = [];
      if (flag === true) {
        for (let i = 0; i < assigneeUser.length; i++) {
          let myArr: any = items;
          items[i] = {
            assignee_user: assigneeUser[i],
            assignee_role: assigneeRole[i],
            contribution: contributionList[i],
            individual_sales: 0
          };
        }

        let flag2 = false;
        if (l5 === l6) {
          flag2 = true;
        }
        let items2: any = [];
        if (flag2 === true) {
          for (let j = 0; j < assigneeOutsidePartner.length; j++) {
            items2[j] = {
              assignee_user: assigneeOutsidePartner[j],
              assignee_role: assigneeOutsidePartnerRole[j],
              contribution: 0,
              individual_sales: 0
            };
          }
          let arr2: any = [];
          for (let n = 0; n < items2.length; n++) {
            if (items2[n].assignee_user || items2[n].assignee_role) {
              arr2.push(items2[n]);
            }
          }
          await saveConstruction(
            history.location.state.state,
            code,
            constructType,
            renewStatus,
            buildingScale,
            name.trim(),
            sitePrefecture,
            siteAddress1.trim(),
            siteAddress2.trim(),
            siteAddress3.trim(),
            remarks,
            contractorPrefecture,
            contractorAddress1.trim(),
            contractorAddress2.trim(),
            contractorAddress3.trim(),
            contractorName.trim(),
            contractorTel.trim(),
            progress,
            plannedCost,
            plannedDays,
            0,
            selectedContractDate !== null ? contractDate : '',
            selectedStartDate !== null ? startDate : '',
            selectedEndDate !== null ? endDate : '',
            selectedBillingDate !== null ? billingDate : '',
            selectedPaymentDate !== null ? paymentDate : '',
            selectedFailureDate !== null ? failureDate : '',
            selectedInspectionDate !== null ? inspectionDate : '',
            contractTaxRate,
            selectedExpectedContractDate !== null ? expectedContractDate : '',
            selectedExpectedStartDate !== null ? expectedStartDate : '',
            selectedExpectedEndDate !== null ? expectedEndDate : '',
            selectedExpectedPaymentDate !== null ? expectedPaymentDate : '',
            smallExpenses,
            items,
            arr2,
            companyName.trim(),
            String(companyCode.trim()),
            String(companyPostalCode1.trim()) +
              String(companyPostalCode2.trim()),
            companyAddress.trim(),
            String(companyPhoneNumber.trim()),
            String(companyFaxNumber.trim()),
            latitude,
            longitude,
            isMarkerChecked,
            possibleTime.trim(),
            parkSpace.trim(),
            smokingRule.trim(),
            importantOthers.trim(),
            janitorName.trim(),
            janitorPhoneNumber.trim(),
            janitorFaxNumber.trim(),
            janitorWorkHours.trim(),
            janitorOthers.trim(),
            smallExpenseItems
          ).then(data => {
            if (data === 'Not logged in!') {
              changeLoggedInData('Not logged in!');
            } else {
              if (typeof data === 'string') {
                setErrorMessage(data);
                setOpen(true);
              } else {
                if (data.error) {
                  setErrorMessage(data.error);
                  setOpen(true);
                } else {
                  setErrorMessage(data.message);
                  setOpenSuccess(true);
                  if (data.construct_id) {
                    setConstructId(data.construct_id);
                    setIsPosted(true);
                  }
                  setTimeout(() => {
                    history.goBack();
                  }, 1500);
                }
              }
            }
          });
        } else {
          setErrorMessage('社外パートナー情報を設定してください。');
          setOpen(true);
        }
      } else {
        setErrorMessage('担当者を設定してください。');
        setOpen(true);
      }
    }
    setShowLinearProgress(false);
  };

  const deleteFunction = (j: number) => {
    if (rowCount.length === 1) {
      setErrorMessage('担当者を設定してください。');
      setOpen(true);
    } else {
      let newAssigneeRole: any = [...assigneeRole];
      let newContributionList: any = [...contributionList];
      let newAssigneeUser: any = [...assigneeUser];
      let newRowCount: any = [...rowCount];
      newAssigneeUser.splice(j, 1);
      newAssigneeRole.splice(j, 1);
      newContributionList.splice(j, 1);
      newRowCount.splice(j, 1);
      if (newAssigneeUser.length !== newRowCount.length) {
        newAssigneeUser.push(0);
      }
      if (newAssigneeRole.length !== newRowCount.length) {
        newAssigneeRole.push(0);
      }
      if (newContributionList.length !== newRowCount.length) {
        newContributionList.push(0);
      }
      setRowCount(newRowCount);
      setAssigneeUser(newAssigneeUser);
      setContributionList(newContributionList);
      setAssigneeRole(newAssigneeRole);
    }
  };

  const deleteFunction2 = (j: number) => {
    let newAssigneeOutsidePartnerRole: any = [...assigneeOutsidePartnerRole];
    let newAssigneeOutsidePartner: any = [...assigneeOutsidePartner];
    let newRowCount2: any = [...rowCount2];
    newAssigneeOutsidePartner.splice(j, 1);
    newAssigneeOutsidePartnerRole.splice(j, 1);
    newRowCount2.splice(j, 1);
    setRowCount2(newRowCount2);
    setAssigneeOutsidePartner(newAssigneeOutsidePartner);
    setAssigneeOutsidePartnerRole(newAssigneeOutsidePartnerRole);
  };

  const handleConstructionNameChange = (text: string) => {
    const rawText = text;
    let cleanText = '';
    let charCount = 0; // 全体の文字数カウント
    let lineCharCount = 0; // 各行の文字数カウント
    let lineCount = 1; // 行数カウント

    for (let i = 0; i < rawText.length; i++) {
      // 文字が改行コードかチェック
      if (rawText[i] === '\n' || rawText[i] === '\r') {
        // Windowsの改行コード（\r\n）を考慮
        if (rawText[i] === '\r' && rawText[i + 1] === '\n') {
          i++;
        }
        lineCount++;
        lineCharCount = 0; // 各行の文字数カウントをリセット

        if (lineCount > 2) {
          alert('2行まで入力可能です');
          break;
        }
        cleanText += rawText[i];
      } else {
        charCount++;
        lineCharCount++;

        // 改行がある場合のみ各行の30文字制限を適用
        if (lineCount > 1 && lineCharCount > 30) {
          alert('1行あたり30文字まで入力可能です');
          break;
        }

        // 全体の60文字制限
        if (charCount > 60) {
          alert('60文字まで入力可能です');
          break;
        }
        cleanText += rawText[i];
      }
    }

    setName(cleanText);
  };

  /**
   * numberで保存されている都道府県のidから都道府県名を取得する
   * @param id
   */
  const changeSitePrefectureName = (id: number) => {
    const prefecture = prefectureData.filter(pref => pref.id === id);

    if (prefecture.length === 1) {
      setSitePrefectureName(prefecture[0]['name']);
    } else {
      setSitePrefectureName('');
    }
  };

  const handleCompanyAdressChange = (text: string) => {
    const rawText = text;
    let cleanText = '';
    let charCount = 0; // 全体の文字数カウント
    let lineCharCount = 0; // 各行の文字数カウント
    let lineCount = 1; // 行数カウント

    for (let i = 0; i < rawText.length; i++) {
      // 文字が改行コードかチェック
      if (rawText[i] === '\n' || rawText[i] === '\r') {
        // Windowsの改行コード（\r\n）を考慮
        if (rawText[i] === '\r' && rawText[i + 1] === '\n') {
          i++;
        }
        lineCount++;
        lineCharCount = 0; // 各行の文字数カウントをリセット

        if (lineCount > 3) {
          alert('3行まで入力可能です');
          break;
        }
        cleanText += rawText[i];
      } else {
        charCount++;
        lineCharCount++;

        // 改行がある場合に各行の20文字制限を適用
        if (lineCount > 1 && lineCharCount > 20) {
          alert('1行あたり20文字まで入力可能です');
          break;
        }

        // 全体の60文字制限
        if (charCount > 60) {
          alert('全体で60文字まで入力可能です');
          break;
        }
        cleanText += rawText[i];
      }
    }

    setCompanyAddress(cleanText);
  };

  const handleCompanyAddressFetch = async () => {
    try {
      const result = await fetchAddressFromPostalCode(
        `${companyPostalCode1}${companyPostalCode2}`
      );

      if (result.success) {
        const addressData = result.data;
        const fullAddress =
          `${addressData.prefecture}${addressData.city}${addressData.suburb}`.trim();
        setCompanyAddress(fullAddress);

        setErrorMessage('');
      } else {
        setErrorMessage(result.message || '住所の取得に失敗しました');
        setOpen(true);
      }
    } catch (error) {
      setErrorMessage(
        'システムエラーが発生しました。住所は手動で入力してください。'
      );
      setOpen(true);
    }
  };

  useEffect(() => {
    changeSitePrefectureName(sitePrefecture);
  }, [sitePrefecture]);

  const convertToLatLong = async (force: boolean = false) => {
    if (isAddressChanged || force) {
      setIsAddressChanged(false);
      return axios
        .get(`/api/v1/constructions/site_address/${site_address}`, {
          headers: {
            withCredentials: true
          }
        })
        .then(response => {
          //googleMapの緯度経度が小数点7桁までなので8桁以降を切り捨て
          //国内は緯度は小数点以上が２桁、経度は3桁
          setLatitude(Number(response.data.latitude.toFixed(5)));
          setLongitude(Number(response.data.longitude.toFixed(5)));
        })
        .catch(err => {
          return err.response;
        });
    }
  };

  const patternState: TTopicPathState = {};
  patternState['/constructions'] = history.location.state;

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <>
      <AppBarComponent
        patternName='constructions_create'
        patternState={patternState}
      />
      <div
        style={{
          overflow: 'hidden',
          backgroundColor: '#F5F5F5',
          minHeight: window.innerHeight
        }}
      >
        <div style={{ margin: 15 }}>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>

          <Snackbar
            open={openSuccess}
            autoHideDuration={4000}
            onClose={handleCloseSuccess}
          >
            <Alert onClose={handleCloseSuccess} severity='success'>
              {errorMessage}
            </Alert>
          </Snackbar>

          <div className='table-top-container-customer'>
            <div style={{ fontWeight: 'bold' }}>
              <Button
                style={{
                  minWidth: 90,
                  marginRight: 15,
                  color: '#758283',
                  backgroundColor: '#F5F5F5',
                  marginBottom: !matches2 ? 10 : 0
                }}
                variant='contained'
                color='secondary'
                onClick={() => {
                  if (history.location.state.params) {
                    history.push('/constructions', history.location.state);
                  } else {
                    history.goBack();
                  }
                }}
                startIcon={<ArrowBackIcon />}
              >
                戻る
              </Button>
            </div>
          </div>

          {showLinearProgress && (
            <LinearProgress className={classes.progress} />
          )}

          <div>
            <div
              className='table-top-container-customer'
              style={{ backgroundColor: '#FFFFFF' }}
            >
              <div
                style={{
                  fontWeight: 'bold',
                  padding: 15,
                  paddingBottom: 0,
                  fontSize: 24
                }}
              >
                工事案件
              </div>
            </div>

            <Grid
              container
              style={{
                backgroundColor: '#FFFFFF',
                paddingBottom: 15,
                marginBottom: 15
              }}
            >
              <Grid item xs={matches2 ? 4 : 12}>
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>工事番号</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={code}
                        onChange={e => {
                          setCode(e.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      工事件名<span>*</span>
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <textarea
                        value={name}
                        placeholder='60文字以内、2行以内'
                        onChange={e => {
                          handleConstructionNameChange(e.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      案件種別<span>*</span>
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainerSelectBox}>
                      <select
                        value={constructType}
                        onChange={e => {
                          setConstructType(parseInt(e.target.value));
                        }}
                        className={classes.selectBoxStyle}
                        name='cars'
                        id='cars'
                        form='carform'
                      >
                        <option value={0}>選択してください</option>
                        {typesData.map((i: any) => (
                          <option value={i.id}>{i.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      新規・リピート<span>*</span>
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                      }}
                    >
                      <div
                        onClick={() => {
                          setRenewStatus(1);
                        }}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: 8
                        }}
                      >
                        <div className='checkbox'>
                          {renewStatus === 1 && <div className='dot' />}
                        </div>
                        <div style={{ fontSize: 16, marginLeft: 5 }}>新規</div>
                      </div>
                      <div
                        onClick={() => {
                          setRenewStatus(2);
                        }}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: 8
                        }}
                      >
                        <div className='checkbox'>
                          {renewStatus === 2 && <div className='dot' />}
                        </div>
                        <div style={{ fontSize: 16, marginLeft: 5 }}>
                          リピート
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>物件規模</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainerSelectBox}>
                      <select
                        onChange={e => {
                          setBuildingScale(parseInt(e.target.value));
                        }}
                        value={buildingScale}
                        className={classes.selectBoxStyle}
                        name='cars'
                        id='cars'
                        form='carform'
                      >
                        <option value={0}>選択してください</option>
                        {scaleData.map((i: any) => (
                          <option value={i.id}>{i.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
                {/* <Divider
                  style={{ backgroundColor: "#CCCCCC", marginLeft: 15 ,width:0.2}}
                /> */}
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer2}>
                    <div className={classes.textContainer}>備考欄</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <textarea
                        value={remarks}
                        onChange={e => {
                          setRemarks(e.target.value);
                        }}
                        className={classes.inputnew}
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>

            <div
              className='table-top-container-customer'
              style={{ backgroundColor: '#FFFFFF' }}
            >
              <div className='question-position'>
                <div
                  style={{
                    fontWeight: 'bold',
                    padding: 15,
                    paddingBottom: 0,
                    paddingRight: 0,
                    fontSize: 24
                  }}
                >
                  契約者
                </div>
                <CustomTooltip
                  title={tooltipContents.contractor}
                  placement='right'
                >
                  <HelpIcon
                    color='action'
                    style={{ marginTop: 16, marginLeft: 12 }}
                  />
                </CustomTooltip>
              </div>
            </div>

            <Grid
              container
              style={{
                backgroundColor: '#FFFFFF',
                paddingBottom: 15,
                marginBottom: 15
              }}
            >
              <Grid item xs={matches2 ? 4 : 12}>
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>契約者名</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={contractorName}
                        onChange={e => {
                          setContractorName(e.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      契約者住所 都道府県
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainerSelectBox}>
                      <select
                        value={contractorPrefecture}
                        onChange={e => {
                          setContractorPrefecture(parseInt(e.target.value));
                        }}
                        className={classes.selectBoxStyle}
                        name='cars'
                        id='cars'
                        form='carform'
                      >
                        <option value={0}>選択してください</option>
                        {prefectureData.map((i: any) => (
                          <option value={i.id}>{i.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      契約者住所 市区町村
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={contractorAddress1}
                        onChange={e => {
                          setContractorAddress1(e.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      契約者住所 町名・番地
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        onChange={e => {
                          setContractorAddress2(e.target.value);
                        }}
                        value={contractorAddress2}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      契約者住所 建物名
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={contractorAddress3}
                        onChange={e => {
                          setContractorAddress3(e.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>連絡先TEL</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={contractorTel}
                        onChange={e => {
                          setContractorTel(e.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
              </Grid>
            </Grid>

            <div
              className='table-top-container-customer'
              style={{ backgroundColor: '#FFFFFF' }}
            >
              <div
                style={{
                  fontWeight: 'bold',
                  padding: 15,
                  paddingBottom: 0,
                  fontSize: 24
                }}
              >
                顧客
              </div>
            </div>

            <Grid
              container
              style={{
                backgroundColor: '#FFFFFF',
                paddingBottom: 15,
                marginBottom: 15
              }}
            >
              <Grid item xs={matches2 ? 4 : 12}>
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>顧客名</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainerSelectBox}>
                      {clientName}
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      顧客住所 都道府県
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainerSelectBox}>
                      {clientPrefecture}
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      顧客住所 市区町村
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainerSelectBox}>
                      {clientAddress1}
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      顧客住所 町名・番地
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainerSelectBox}>
                      {clientAddress2}
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>顧客住所 建物名</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainerSelectBox}>
                      {clientAddress3}
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>顧客TEL</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainerSelectBox}>
                      {clientTel}
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
              </Grid>
            </Grid>
            {userMenu != 'Storage' && (
              <>
                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    担当者情報
                  </div>
                </div>
                <div style={{ backgroundColor: '#FFFFFF' }}>
                  <div
                    style={{
                      backgroundColor: '#FFFFFF',
                      marginLeft: 15,
                      marginRight: 15,
                      marginBottom: 0
                    }}
                  >
                    <TableContainer component={Paper}>
                      <Table aria-label='customized table'>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell
                              className={classes.table}
                              align='left'
                            >
                              担当者名<span>*</span>
                            </StyledTableCell>
                            <StyledTableCell
                              className={classes.table}
                              align='left'
                            >
                              担当役割<span>*</span>
                            </StyledTableCell>
                            <StyledTableCell
                              className={classes.table}
                              align='left'
                            >
                              貢献度（％）<span>*</span>
                            </StyledTableCell>
                            <StyledTableCell
                              className={classes.table}
                              align='left'
                            >
                              個人別売上
                            </StyledTableCell>
                            <StyledTableCell
                              className={classes.table}
                              align='left'
                              style={{ minWidth: 110 }}
                            ></StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowCount.map((i: any, j: number) => (
                            <StyledTableRow>
                              <StyledTableCell
                                style={{ minWidth: 140 }}
                                align='left'
                              >
                                <select
                                  value={assigneeUser[j]}
                                  onChange={text => {
                                    let newNameArr: any = [...assigneeUser];
                                    newNameArr[j] = parseInt(text.target.value);
                                    setAssigneeUser(newNameArr);
                                  }}
                                  className={classes.inputBottom}
                                  style={{ height: 35 }}
                                  name='cars'
                                  id='cars'
                                  form='carform'
                                >
                                  <option value={0}>選択してください</option>
                                  {/* role_id=4(社外パートナー)の場合はスキップ */}
                                  {getUserSelectOptions(
                                    userData.filter((i: any) => i.role_id !== 4)
                                  )}
                                </select>
                              </StyledTableCell>

                              <StyledTableCell
                                style={{ minWidth: 140 }}
                                align='left'
                              >
                                <select
                                  value={assigneeRole[j]}
                                  onChange={text => {
                                    let newNameArr: any = [...assigneeRole];
                                    newNameArr[j] = parseInt(text.target.value);
                                    setAssigneeRole(newNameArr);
                                  }}
                                  className={classes.inputBottom}
                                  style={{ height: 35 }}
                                  name='cars'
                                  id='cars'
                                  form='carform'
                                >
                                  <option value={0}>選択してください</option>
                                  {assigneeRoleData.map((i: any) => {
                                    if (i.id === 5) {
                                      return null; // id=5の場合はスキップする
                                    }
                                    return (
                                      <option value={i.id}>{i.name}</option>
                                    );
                                  })}
                                </select>
                              </StyledTableCell>

                              <StyledTableCell
                                style={{ minWidth: 140 }}
                                align='left'
                              >
                                <Grid
                                  container
                                  direction='row'
                                  alignItems='center'
                                >
                                  <Grid>
                                    <input
                                      type='number'
                                      min='0'
                                      value={contributionList[j]}
                                      onChange={text => {
                                        let newNameArr: any = [
                                          ...contributionList
                                        ];
                                        newNameArr[j] = parseFloat(
                                          text.target.value
                                        );
                                        setContributionList(newNameArr);
                                      }}
                                      className={classes.inputBottomAlignRight}
                                      onWheel={(e: any) => e.target.blur()}
                                    />
                                  </Grid>
                                  <Grid style={{ marginLeft: 20 }}>%</Grid>
                                </Grid>
                              </StyledTableCell>

                              <StyledTableCell
                                style={{ minWidth: 140 }}
                                align='right'
                              >
                                <div style={{ fontSize: 16 }}>0円</div>
                              </StyledTableCell>
                              <StyledTableCell
                                style={{ minWidth: 110 }}
                                align='center'
                              >
                                <Button
                                  style={{ backgroundColor: buttonColor }}
                                  variant='contained'
                                  color='primary'
                                  startIcon={<DeleteIcon />}
                                  onClick={() => {
                                    deleteFunction(j);
                                  }}
                                >
                                  削除
                                </Button>
                              </StyledTableCell>
                            </StyledTableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>

                  <div
                    style={{
                      marginTop: 15,
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginRight: 15
                    }}
                  >
                    <div />
                    <CustomTooltip
                      title={tooltipContents.constructionsCreateManager}
                      placement='left'
                    >
                      <Button
                        style={{ backgroundColor: buttonColor }}
                        variant='contained'
                        color='secondary'
                        startIcon={<AddToPhotosIcon />}
                        onClick={() => {
                          let len = rowCount.length - 1;
                          let contributionSum = 0;
                          for (let i = 0; i < contributionList.length; i++) {
                            contributionSum += contributionList[i];
                          }
                          if (
                            (rowCount.length === 0 ||
                              (assigneeUser[len] &&
                                assigneeRole[len] &&
                                contributionList[len])) &&
                            contributionSum <= 100
                          ) {
                            setRowCount([...rowCount, 1]);
                          } else {
                            if (contributionSum > 100) {
                              setErrorMessage(
                                '貢献度100％を超えることはできません。'
                              );
                              setOpen(true);
                            } else {
                              setOpen(true);
                              setErrorMessage('すべての項目の入力が必須です。');
                            }
                          }
                        }}
                      >
                        追加
                      </Button>
                    </CustomTooltip>
                  </div>
                  <div
                    style={{
                      height: 15,
                      backgroundColor: '#F5F5F5',
                      marginTop: 15
                    }}
                  />
                </div>
              </>
            )}

            {userMenu != 'Storage' && (
              <>
                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    社外パートナー情報
                  </div>
                </div>

                <div style={{ backgroundColor: '#FFFFFF' }}>
                  <div
                    style={{
                      backgroundColor: '#FFFFFF',
                      marginLeft: 15,
                      marginRight: 15,
                      marginBottom: 0
                    }}
                  >
                    <TableContainer component={Paper}>
                      <Table aria-label='customized table'>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell
                              className={classes.table}
                              align='left'
                            >
                              氏名
                            </StyledTableCell>
                            <StyledTableCell
                              className={classes.table}
                              align='left'
                            >
                              権限
                            </StyledTableCell>

                            <StyledTableCell
                              className={classes.table}
                              align='left'
                              style={{ minWidth: 110 }}
                            ></StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowCount2.map((i: any, j: number) => (
                            <StyledTableRow>
                              <StyledTableCell
                                className={classes.inputBottom}
                                style={{ minWidth: 140, width: '20%' }}
                                align='left'
                              >
                                <select
                                  value={assigneeOutsidePartner[j]}
                                  onChange={text => {
                                    let newNameArr: any = [
                                      ...assigneeOutsidePartner
                                    ];
                                    newNameArr[j] = parseInt(text.target.value);
                                    setAssigneeOutsidePartner(newNameArr);
                                  }}
                                  className={classes.inputBottom}
                                  style={{ height: 35 }}
                                  name='cars'
                                  id='cars'
                                  form='carform'
                                >
                                  <option value={0}>選択してください</option>
                                  {userData.map((i: any) =>
                                    // role_id=4(社外パートナー)のみ表示
                                    i.role_id === 4 ? (
                                      <option value={i.id}>{i.name}</option>
                                    ) : null
                                  )}
                                </select>
                              </StyledTableCell>

                              <StyledTableCell
                                className={classes.inputBottom}
                                style={{ minWidth: 140, width: '20%' }}
                                align='left'
                              >
                                <select
                                  value={assigneeOutsidePartnerRole[j]}
                                  onChange={text => {
                                    let newNameArr: any = [
                                      ...assigneeOutsidePartnerRole
                                    ];
                                    newNameArr[j] = parseInt(text.target.value);
                                    setAssigneeOutsidePartnerRole(newNameArr);
                                  }}
                                  className={classes.inputBottom}
                                  style={{
                                    height: 35,
                                    minWidth: 110,
                                    width: '80%'
                                  }}
                                >
                                  <option value={0}>選択してください</option>
                                  <option value={5}>社外パートナー</option>
                                </select>
                              </StyledTableCell>
                              {rowCount2.length === 1 && ( // 1行のみの場合
                                <>
                                  <StyledTableCell
                                    style={{ minWidth: 110, width: '10%' }}
                                    align='right'
                                  ></StyledTableCell>
                                </>
                              )}
                              {rowCount2.length != 1 && ( // ２行以上の場合
                                <>
                                  <StyledTableCell
                                    style={{ minWidth: 110, width: '10%' }}
                                    align='right'
                                  >
                                    <Button
                                      style={{ backgroundColor: buttonColor }}
                                      variant='contained'
                                      color='primary'
                                      startIcon={<DeleteIcon />}
                                      onClick={() => {
                                        deleteFunction2(j);
                                      }}
                                    >
                                      削除
                                    </Button>
                                  </StyledTableCell>
                                </>
                              )}
                            </StyledTableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>

                  <div
                    style={{
                      marginTop: 15,
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginRight: 15
                    }}
                  >
                    <div />
                    <CustomTooltip
                      title={tooltipContents.constructionsCreateOutsidePartner}
                      placement='left'
                    >
                      <Button
                        style={{ backgroundColor: buttonColor }}
                        variant='contained'
                        color='secondary'
                        startIcon={<AddToPhotosIcon />}
                        onClick={() => {
                          let len2 = rowCount2.length - 1;
                          if (
                            assigneeOutsidePartner[len2] &&
                            assigneeOutsidePartnerRole[len2]
                          ) {
                            setRowCount2([...rowCount2, 1]);
                          } else {
                            setOpen(true);
                            setErrorMessage('すべての項目の入力が必須です。');
                          }
                        }}
                      >
                        追加
                      </Button>
                    </CustomTooltip>
                  </div>
                  <div
                    style={{
                      height: 15,
                      backgroundColor: '#F5F5F5',
                      marginTop: 15
                    }}
                  />
                </div>
              </>
            )}

            {userMenu != 'Storage' && userMenu != 'SiteManage' && (
              <>
                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    管理情報
                  </div>
                </div>
                <Grid style={{ backgroundColor: '#FFFFFF' }} container>
                  <Grid item xs={matches2 ? 4 : 12}>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          受注金額（税別）
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>0円</div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingTop: 15
                  }}
                  container
                >
                  <Grid item xs={matches2 ? 4 : 12}>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          受注金額（税込）
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>0円</div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          入金額（税込）
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>0円</div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          未収金額（税込）
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>0円</div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>

                  <Grid item xs={matches2 ? 4 : 12}>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          計画原価（円）
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <NumberInput
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              setPlannedCost(parseInt(e.target.value));
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>実行原価</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>
                          {executionCost === ''
                            ? '0円'
                            : parsePrice(executionCost)}
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          原価予実差異
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>0円</div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>

                  <Grid item xs={matches2 ? 4 : 12}>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>計画粗利率</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}></div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>実行粗利率</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          className={classes.inputContainerSelectBoxAlignRight}
                        >
                          0 %
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          粗利率予実差異
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          className={classes.inputContainerSelectBoxAlignRight}
                        >
                          0 %
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingTop: 15,
                    paddingBottom: 15,
                    marginBottom: 15
                  }}
                  container
                >
                  <Grid item xs={matches2 ? 4 : 12}>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>計画粗利</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>0円</div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>実行粗利</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>0円</div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          粗利予実差異
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>0円</div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>

                  <Grid item xs={matches2 ? 4 : 12}>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          小口経費（円）（税別）
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>
                          {smallExpenses === ''
                            ? '0円'
                            : parsePrice(smallExpenses)}
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          材料費（税別）
                          <br />
                          （実行予算材料費）
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>
                          0円
                          <br />
                          <span style={{ color: 'blue' }}>(0円)</span>
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          外注費（税別）
                          <br />
                          （実行予算外注費）
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>
                          0円
                          <br />
                          <span style={{ color: 'blue' }}>(0円)</span>
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>

                  <Grid item xs={matches2 ? 4 : 12}>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div
                          className={classes.textContainer}
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          追加原価
                          <CustomTooltip
                            title={tooltipContents.additionalCost}
                            placement='right'
                            interactive={true}
                          >
                            <HelpIcon
                              style={{ color: 'white', marginLeft: 8 }}
                            />
                          </CustomTooltip>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          className={classes.inputContainerSelectBoxAlignRight}
                        >
                          0円
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          予定工事日数
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainerSelectBox}>
                          {plannedDays > 0 ? `${plannedDays}  日` : ''}
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          日割実行粗利
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>0円</div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>
                </Grid>

                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    小口経費明細
                  </div>
                </div>

                <div style={{ backgroundColor: '#FFFFFF' }}>
                  <div
                    style={{
                      backgroundColor: '#FFFFFF',
                      marginLeft: 15,
                      marginRight: 15,
                      marginBottom: 0
                    }}
                  >
                    <TableContainer component={Paper}>
                      <Table aria-label='customized table'>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell
                              className={classes.table}
                              align='left'
                              style={{ width: '50%', textAlign: 'center' }}
                            >
                              経費項目
                            </StyledTableCell>
                            <StyledTableCell
                              className={classes.table}
                              align='left'
                              style={{ width: '30%', textAlign: 'center' }}
                            >
                              金額<span>*</span>
                            </StyledTableCell>
                            <StyledTableCell
                              className={classes.table}
                              align='left'
                              style={{ width: '20%' }}
                            ></StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {smallExpenseItems.map((i: any, j: number) => (
                            <StyledTableRow key={i.id}>
                              <StyledTableCell
                                style={{ minWidth: 140 }}
                                align='left'
                              >
                                <div className={classes.inputContainer}>
                                  <input
                                    value={i.name}
                                    placeholder='30文字以内で入力'
                                    type='text'
                                    onChange={text => {
                                      let newSmallExpenseItems = [
                                        ...smallExpenseItems
                                      ];
                                      newSmallExpenseItems[j].name =
                                        text.target.value;
                                      setSmallExpenseItems(
                                        newSmallExpenseItems
                                      );
                                    }}
                                    className={classes.input}
                                  />
                                </div>
                              </StyledTableCell>

                              <StyledTableCell
                                style={{ minWidth: 140 }}
                                align='left'
                              >
                                <NumberInput
                                  className={classes.input}
                                  value={i.price}
                                  onChange={(e: any) => {
                                    let newSmallExpenseItems = [
                                      ...smallExpenseItems
                                    ];
                                    newSmallExpenseItems[j].price = parseInt(
                                      e.target.value
                                    );
                                    if (isNaN(parseInt(e.target.value))) {
                                      newSmallExpenseItems[j].price = '';
                                    }
                                    setSmallExpenseItems(newSmallExpenseItems);
                                    additionSmallExpenseItemsPrice();
                                  }}
                                />
                              </StyledTableCell>

                              <StyledTableCell
                                style={{ minWidth: 110 }}
                                align='center'
                              >
                                <Button
                                  style={{ backgroundColor: buttonColor }}
                                  variant='contained'
                                  color='primary'
                                  startIcon={<DeleteIcon />}
                                  onClick={() => {
                                    deleteSmallExpenseItems(i.id);
                                  }}
                                >
                                  削除
                                </Button>
                              </StyledTableCell>
                            </StyledTableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>

                  <div
                    style={{
                      marginTop: 15,
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginRight: 15
                    }}
                  >
                    <div />
                    <CustomTooltip
                      title={tooltipContents.constructionsCreateExpenses}
                      placement='left'
                    >
                      <Button
                        style={{ backgroundColor: buttonColor }}
                        variant='contained'
                        color='secondary'
                        startIcon={<AddToPhotosIcon />}
                        onClick={() => {
                          addNewSmallExpenseItems();
                        }}
                      >
                        追加
                      </Button>
                    </CustomTooltip>
                  </div>
                  <div
                    style={{
                      height: 15,
                      backgroundColor: '#F5F5F5',
                      marginTop: 15
                    }}
                  />
                </div>

                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    スケジュール
                  </div>
                </div>
                <Grid
                  container
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingBottom: 15,
                    marginBottom: 15
                  }}
                >
                  <Grid item xs={matches2 ? 4 : 12}>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>契約日</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 15,
                            backgroundColor: '#FFFFFF',
                            height: 42,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            width: '100%'
                          }}
                          className={'select-div-div'}
                        >
                          <DatePickerInput
                            date={selectedContractDate}
                            onChange={handleContractDateChange}
                            id={'contract_date'}
                            emptyLabel='連絡日'
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>着工日</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 15,
                            backgroundColor: '#FFFFFF',
                            height: 42,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            width: '100%'
                          }}
                          className={'select-div-div'}
                        >
                          <DatePickerInput
                            date={selectedStartDate}
                            onChange={handleStartDateChange}
                            id={'start_date'}
                            emptyLabel='連絡日'
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>竣工日</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 15,
                            backgroundColor: '#FFFFFF',
                            height: 42,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            width: '100%'
                          }}
                          className={'select-div-div'}
                        >
                          <DatePickerInput
                            date={selectedEndDate}
                            onChange={handleEndDateChange}
                            id={'end_date'}
                            emptyLabel='日付を選択'
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>請求日</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 15,
                            backgroundColor: '#FFFFFF',
                            height: 42,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            width: '100%'
                          }}
                          className={'select-div-div'}
                        >
                          <DatePickerInput
                            date={selectedBillingDate}
                            onChange={handleBillingDateChange}
                            id={'billing_date'}
                            emptyLabel='日付を選択'
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>完工入金日</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 15,
                            backgroundColor: '#FFFFFF',
                            height: 42,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            width: '100%'
                          }}
                          className={'select-div-div'}
                        >
                          <DatePickerInput
                            date={selectedPaymentDate}
                            onChange={handlePaymentDateChange}
                            id={'payment_date'}
                            emptyLabel='日付を選択'
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>不成立日</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 15,
                            backgroundColor: '#FFFFFF',
                            height: 42,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            width: '100%'
                          }}
                          className={'select-div-div'}
                        >
                          <DatePickerInput
                            date={selectedFailureDate}
                            onChange={handleFailureDateChange}
                            id={'failure_date'}
                            emptyLabel='日付を選択'
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>点検日</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 15,
                            backgroundColor: '#FFFFFF',
                            height: 42,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            width: '100%'
                          }}
                          className={'select-div-div'}
                        >
                          <DatePickerInput
                            date={selectedInspectionDate}
                            onChange={handleInspectionDateChange}
                            id={'inspection_date'}
                            emptyLabel='日付を選択'
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>
                  <Grid item xs={matches2 ? 4 : 12}>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>契約予定日</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 15,
                            backgroundColor: '#FFFFFF',
                            height: 42,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            width: '100%'
                          }}
                          className={'select-div-div'}
                        >
                          <DatePickerInput
                            date={selectedExpectedContractDate}
                            onChange={handleExpectedContractDateChange}
                            id={'expected_contract_date'}
                            emptyLabel='日付を選択'
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>着工予定日</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 15,
                            backgroundColor: '#FFFFFF',
                            height: 42,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            width: '100%'
                          }}
                          className={'select-div-div'}
                        >
                          <DatePickerInput
                            date={selectedExpectedContractDate}
                            onChange={handleExpectedContractDateChange}
                            id={'expected_contract_date'}
                            emptyLabel='日付を選択'
                            maxDate={
                              selectedExpectedEndDate
                                ? selectedExpectedEndDate
                                : undefined
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>竣工予定日</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 15,
                            backgroundColor: '#FFFFFF',
                            height: 42,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            width: '100%'
                          }}
                          className={'select-div-div'}
                        >
                          <DatePickerInput
                            date={selectedExpectedEndDate}
                            onChange={handleExpectedEndDateChange}
                            id={'expected_end_date'}
                            emptyLabel='日付を選択'
                            minDate={
                              selectedExpectedContractDate
                                ? selectedExpectedContractDate
                                : undefined
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>入金予定日</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 15,
                            backgroundColor: '#FFFFFF',
                            height: 42,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            width: '100%'
                          }}
                          className={'select-div-div'}
                        >
                          <DatePickerInput
                            date={selectedExpectedPaymentDate}
                            onChange={handleExpectedPaymentDateChange}
                            id={'expected_payment_date'}
                            emptyLabel='日付を選択'
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>

                  <Grid item xs={matches2 ? 4 : 12}>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          進行状況<span>*</span>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainerSelectBox}>
                          <select
                            value={progress}
                            onChange={e => {
                              setProgress(parseInt(e.target.value));
                            }}
                            className={classes.selectBoxStyle}
                            name='cars'
                            id='cars'
                            form='carform'
                          >
                            <option value={0}>進行状況</option>
                            <option value={1}>未契約</option>
                            <option value={2}>営業中(Aランク)</option>
                            <option value={3}>営業中(Bランク)</option>
                            <option value={4}>営業中(Cランク)</option>
                            <option value={5}>契約</option>
                            <option value={6}>工事中</option>
                            <option value={7}>竣工</option>
                            <option value={8}>引渡</option>
                            <option value={9}>入金・完工</option>
                            <option value={10}>不成立</option>
                            <option value={11}>是正</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          契約書用税率 (%)
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainerSelectBox}>
                          <select
                            value={contractTaxRate}
                            onChange={e => {
                              setContractTaxRate(parseInt(e.target.value));
                            }}
                            className={classes.selectBoxStyle}
                          >
                            <option value={10}>10</option>
                            <option value={0}>0</option>
                            {/* <option value={5}>5</option> */}
                            <option value={8}>8</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>
                </Grid>

                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div className='question-position'>
                    <div
                      style={{
                        fontWeight: 'bold',
                        padding: 15,
                        paddingBottom: 0,
                        paddingRight: 0,
                        fontSize: 24
                      }}
                    >
                      自社情報
                    </div>
                    <CustomTooltip
                      title={tooltipContents.constructionsCreateTenant}
                      placement='right'
                    >
                      <HelpIcon
                        color='action'
                        style={{ marginTop: 16, marginLeft: 12 }}
                      />
                    </CustomTooltip>
                  </div>
                </div>

                <Grid
                  container
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingBottom: 15,
                    marginBottom: 15
                  }}
                >
                  <Grid item xs={matches2 ? 6 : 12}>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>会社名</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputMainContainer}>
                          <div className={classes.inputContainer}>
                            <input
                              value={companyName}
                              type='text'
                              onChange={text => {
                                setCompanyName(text.target.value);
                              }}
                              className={classes.input}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>登録番号</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputMainContainer}>
                          <div className={classes.inputContainer}>
                            <input
                              value={companyCode}
                              maxLength={30}
                              type='text'
                              onChange={text => {
                                setCompanyCode(text.target.value);
                              }}
                              className={classes.input}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>郵便</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputMainContainer}>
                          <div className={classes.inputContainer}>
                            <div className={classes.inputContainer}>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center'
                                }}
                              >
                                <input
                                  value={companyPostalCode1}
                                  type='text'
                                  onChange={text => {
                                    setCompanyPostalCode1(text.target.value);
                                  }}
                                  className={classes.inputPostalCode}
                                  style={{ width: 60 }}
                                />
                                <span style={{ margin: 5 }}> - </span>
                                <input
                                  value={companyPostalCode2}
                                  type='text'
                                  maxLength={4}
                                  onChange={text => {
                                    setCompanyPostalCode2(text.target.value);
                                  }}
                                  className={classes.inputPostalCode}
                                  style={{ width: 80 }}
                                />
                                <Button
                                  style={{
                                    backgroundColor: buttonColor,
                                    marginLeft: 6,
                                    padding: '5px 10px',
                                    width: 'auto',
                                    minWidth: '80px'
                                  }}
                                  variant='contained'
                                  color='secondary'
                                  onClick={handleCompanyAddressFetch}
                                >
                                  住所反映
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div
                      className={classes.subContainer}
                      style={{ marginBottom: 15 }}
                    >
                      <div className={classes.textMainContainer1}>
                        <div className={classes.textContainer1}>所在地</div>
                      </div>
                      <div className={classes.inputMainContainer1}>
                        <div className={classes.inputContainer}>
                          <textarea
                            value={companyAddress}
                            placeholder='60文字以内、3行以内'
                            onChange={e => {
                              handleCompanyAdressChange(e.target.value);
                            }}
                            className={classes.input1}
                            style={{ height: 80, maxHeight: 100 }}
                          />
                        </div>
                      </div>
                    </div>
                  </Grid>

                  <Grid
                    item
                    xs={matches2 ? 6 : 12}
                    style={{ paddingRight: matches2 ? 15 : 0 }}
                  >
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>電話番号</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputMainContainer}>
                          <div className={classes.inputContainer}>
                            <input
                              value={companyPhoneNumber}
                              type='text'
                              maxLength={13}
                              onChange={text => {
                                setCompanyPhoneNumber(text.target.value);
                              }}
                              className={classes.input}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>Fax番号</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputMainContainer}>
                          <div className={classes.inputContainer}>
                            <input
                              value={companyFaxNumber}
                              type='text'
                              maxLength={13}
                              onChange={text => {
                                setCompanyFaxNumber(text.target.value);
                              }}
                              className={classes.input}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    現場情報
                  </div>
                </div>
                <Grid
                  container
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingBottom: 15,
                    marginBottom: 15
                  }}
                >
                  <Grid item xs={matches2 ? 4 : 12}>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          現場住所/都道府県
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainerSelectBox}>
                          <select
                            value={sitePrefecture}
                            onChange={e => {
                              setSitePrefecture(parseInt(e.target.value));
                              setIsAddressChanged(true);
                              setIsMarkerChecked(false);
                            }}
                            onBlur={() => {
                              convertToLatLong();
                            }}
                            className={classes.selectBoxStyle}
                            name='cars'
                            id='cars'
                            form='carform'
                          >
                            <option value={0}>選択してください</option>
                            {prefectureData.map((i: any) => (
                              <option value={i.id}>{i.name}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          現場住所/市区町村
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={siteAddress1}
                            onChange={e => {
                              setSiteAddress1(e.target.value);
                              setIsAddressChanged(true);
                              setIsMarkerChecked(false);
                            }}
                            onBlur={() => {
                              convertToLatLong();
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          現場住所/町名・番地
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={siteAddress2}
                            onChange={e => {
                              setSiteAddress2(e.target.value);
                              setIsAddressChanged(true);
                              setIsMarkerChecked(false);
                            }}
                            onBlur={() => {
                              convertToLatLong();
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div
                      className={classes.subContainer}
                      style={{ marginBottom: 15 }}
                    >
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          現場住所建物名/部屋番号など
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={siteAddress3}
                            onChange={e => {
                              setSiteAddress3(e.target.value);
                              setIsAddressChanged(true);
                              setIsMarkerChecked(false);
                            }}
                            onBlur={() => {
                              convertToLatLong();
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={matches2 ? 4 : 12}>
                    <ConstructSiteMap
                      latitude={latitude}
                      longitude={longitude}
                      setLatitude={setLatitude}
                      setLongitude={setLongitude}
                      convertToLatLng={convertToLatLong}
                      isMarkerChecked={isMarkerChecked}
                      setIsMarkerChecked={setIsMarkerChecked}
                    />
                  </Grid>
                  <Grid item xs={matches2 ? 4 : 12}>
                    <ConstructionSiteImg
                      isPosted={isPosted}
                      isUpdated={false}
                      construct_id={constructId}
                      setOpen={setOpen}
                      setErrorMessage={setErrorMessage}
                      resetIsUpdated={() => {}}
                    />
                  </Grid>
                </Grid>
                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div className='question-position'>
                    <div
                      style={{
                        fontWeight: 'bold',
                        padding: 15,
                        paddingBottom: 0,
                        paddingRight: 0,
                        fontSize: 24
                      }}
                    >
                      施工に関する注意点
                    </div>
                  </div>
                </div>
                <Grid
                  container
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingBottom: 15,
                    marginBottom: 15
                  }}
                >
                  <Grid item xs={matches2 ? 4 : 12}>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer1}>
                        <div className={classes.textContainer1}>
                          工事可能時間
                        </div>
                      </div>
                      <div className={classes.inputMainContainer1}>
                        <div className={classes.inputContainer}>
                          <textarea
                            value={possibleTime}
                            onChange={text => {
                              setPossibleTime(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          駐車スペース
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <textarea
                            value={parkSpace}
                            onChange={text => {
                              setParkSpace(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>喫煙ルール</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <textarea
                            value={smokingRule}
                            onChange={text => {
                              setSmokingRule(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>その他</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <textarea
                            value={importantOthers}
                            onChange={text => {
                              setImportantOthers(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>

                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div className='question-position'>
                    <div
                      style={{
                        fontWeight: 'bold',
                        padding: 15,
                        paddingBottom: 0,
                        paddingRight: 0,
                        fontSize: 24
                      }}
                    >
                      管理会社情報
                    </div>
                  </div>
                </div>
                <Grid
                  container
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingBottom: 15,
                    marginBottom: 15
                  }}
                >
                  <Grid item xs={matches2 ? 4 : 12}>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>管理人名</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={janitorName}
                            type='text'
                            onChange={text => {
                              setJanitorName(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>管理人TEL</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={janitorPhoneNumber}
                            type='text'
                            onChange={text => {
                              setJanitorPhoneNumber(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>管理人FAX</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={janitorFaxNumber}
                            type='text'
                            onChange={text => {
                              setJanitorFaxNumber(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>勤務時間</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <textarea
                            value={janitorWorkHours}
                            onChange={text => {
                              setJanitorWorkHours(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>その他</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <textarea
                            value={janitorOthers}
                            onChange={text => {
                              setJanitorOthers(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
          </div>
        </div>
        <div style={{ height: 160 }} />
        <div
          className='save-btn-container'
          style={{
            backgroundColor: '#FFFFFF',
            position: 'fixed',
            bottom: 0,
            width: '100%',
            display: 'flex',
            justifyContent: 'space-around'
          }}
        >
          <div />
          <div>
            <Button
              onClick={saveConstructionDetails}
              style={{
                paddingLeft: 50,
                paddingRight: 50,
                margin: 20,
                backgroundColor: buttonColor
              }}
              variant='contained'
              color='primary'
              disabled={showLinearProgress}
            >
              保存
            </Button>
          </div>
          <div />
        </div>
      </div>
    </>
  );
};
